const commissionList = () => import('@/views/main/commission/list/list.vue')
export default {
  path: '/main/commission/list',
  name: 'commissionList',
  component: commissionList,
  children: []
}
